tag course-cta
	css .chariot ta:center d:vflex ji:center ai:stretch
	css .chariot c:green6 rd:lg p:6 bd:1px solid clear # backdrop-filter: blur(20px) 
	css .chariot bg:green2/80 bxs:lg c:$night bc:green2 bcb:green3 o@loading:0.2 tween:opacity 0.5s

	css .title font-style:italic fs:xl/1.3 fw:500 w:<200px
	css .group-head my:3 c:green7 fw:600 m:3 @880:3 0
	css .flounder bgc:blue0/80 h:70px p:10px pos:fixed b:0px l:0px w:100%
	
	css .bullet mb:2 fs:md @1060:lg- @1250:lg
		@before content: '❍' pr:2

	css & @enrolled bg:white/80 bc:white bcb:white rd:lg
	css section ofx:hidden w:100%

	css section.chariot
		pos:fixed @880:relative b:0px l:0px
		h:70px @880:auto d:flex @880:block fld:row ai:center jc:space-between
		bgc:var(--lemony) @880:white

	def hydrate
		innerHTML = ''
		schedule!
		render!

	get course
		store.course

	get content
		course..sections..content

	get enrolled
		course.membership

	get uid
		course.membership.uid
	
	get completed?
		course.membership..completed

	get certificate?
		course.certificate

	def enroll
		let res = await window.$api.post("/course/{course.id}/enroll")
		if res.enrollment
			window.$api.track("Course", "Enrolled", course.id)
			window.gtag "event", "course_enrolled", { course_id: course.id }
			window.location.href = course.scrims[0].contextualUrl(course)

	def unenroll
		if window.confirm "Are you sure you want to unenroll from {course.title}?"
			const res = await window.$api.post("/course/{course.id}/unenroll")
			if res.unenrolled
				window.$api.track("Course", "Unenrolled", course.id)
				window.location.href = "/allcourses"

	def progress
		let prog = Math.round course.progress * 100
		let next = course.next
		let first = course.scrims[0] or {}

		<section.chariot>
			if next
				<.group-head[d:none @880: block mt:0]> <span> "Jump back in"
				<.item[ta:left ofx:hidden]>
					<h4.truncate[fs:md/1.1 fw:500]> next.title
					if next.mod
						<div[fs:sm c:gray7 mb:0 @880:2]> "In {next.mod.title}"
				<a.button[mt:0 @880:4] href=next.contextualUrl(course)> "Go to lesson"
				if enrolled
					<p.small[d:none @880:block mt:6]> "Leaving course? {<a.small.link @click=unenroll> " Unenroll"}"
			else
				<.group-head[d:none @880:block]> <span> "Get started"
				<.item[ta:left]>
					<div.truncate[fs:md/1.2 fw:500]> first.title
					if first.mod
						<div[fs:sm c:gray7 mb:0 @880:2]> "In {first.mod.title}"
				<a.button[mt:0 @880:4].white href=first.contextualUrl(course)> "Go to lesson"
				if enrolled
					<p.small[d:none @880:block mt:6]> "Leaving course? {<a.small.link @click=unenroll> " Unenroll"}"
			if completed? and certificate?
				<.group-head[d:none @880: block mt:10]> "Certificate unlocked!"
				<a.button.white.sm[mt:0] href="/certificate/{uid}/{course.id}"> "Open certificate"
			elif completed? and !certificate?
				<.group-head[d:none @880: block mt:10 mb:0]> "Well done, course completed!"
				<div> "On to your "
					<a href="/allcourses"> "next conquest!"
				
			elif prog > 0
				<.group-head[d:none @880:block]> <span> "Your progress"
				<div[d:none @880:block bg:gray2 rd:md my:2]> <.progress[h:2 rd:md bg:green4 w: calc($progress * 100%)]>
				<div[d:none @880:block fs:sm c:green9]>
					certificate? ? "You are {prog}% on the way to unlocking your certificate." : "You are {prog}% on your way."
				if course.id == 'gfrontend'
					<div[d:none @880:block fs:sm font-style:italic mt:4]> "Did your progress decrease? Don't worry, please { <a[fs:sm] href="https://scrimba.com/links/progress-decrease"> "read this" }."

	def render
		<self>
			# Free/Enroll version
			<div[d:none @free:block @subscriber:block @enrolled:none]>
				<div[d:none @880:block].chariot>
					<a[mb:4 as:center d:none @guest:hflex].button href="#sign-in"> "Enroll for free"
					<a[d:block @guest:none @has-access:block mb:4 mx:auto as:center].button @click=enroll> "Get started!"
					<p[fw:500]> "Join {course.student_count} other students"
					<div[d:none @guest:contents]>
						<.group-head> <p> "Log in to get"
						<.bullets[ta:left]>
							<.bullet> "Access to all our free courses"
							<.bullet> "Interactive hands-on content"
							<.bullet> "100s of code challenges"
							<.bullet> "Join a friendly community"
				<div[d:flex @880:none jai:center].flounder>
					<a[d:none @guest:hflex].button.sm href="#sign-in"> "Enroll for free"
					<form[d:contents @guest:none] action="/course/{course.id}/enroll" method="post">
						<button.button.sm type="submit"> "Get started!"


			# Subscribe version
			<div[d:block @free:none @subscriber:none @enrolled:none]>
				<div[d:none @880:block].chariot>
					<a[d:none @1200:block mb:4].button href="#join"> "Subscribe to access!"
					<a[d@1200:none mb:4].button.sm href="#join"> "Subscribe to access!"

					<p.small[c:green9]> "Subscribe to access to this course and ALL other courses. You get a 30-day money-back guarantee, no questions asked."
					if content
						<.group-head> <p> "This {course.type} includes"
						<.bullets[ta:left]>
							for usp in content
								<.bullet> usp
					else
						<.group-head> <p> "Subscription includes"
						<.bullets[ta:left]>
							<.bullet> "All courses and career paths"
							<.bullet> "100s of coding challenges"
							<.bullet> "Certificates of completion"
							<.bullet> "Exclusive Pro members chat"

				# Bottom bar for small screens
				<div[d:flex @880:none ai:center jc:center].flounder>
					<a[d:hflex m:0].button.sm href="#join"> "Subscribe now!"
					# <span[d:block]> "New Years discount"

			# Progress version (when enrolled)
			<div[d:none @enrolled:contents]>
				if $web$
					progress!
